<ion-header class="ion-no-border">
  <ion-toolbar no-border class="home-header ion-no-border">
    <div class="logo logo-top"></div>
    <div class="logo logo-bottom"></div>
    <!--
    <ion-buttons slot="end">
      <ion-button class="flag-icon flag-icon-{{ selectedCountryCode | lowercase }}">
        &nbsp;{{ selectedLanguageName }}&nbsp;<ion-icon name="arrow-dropdown"></ion-icon>
      </ion-button>
    </ion-buttons>
    -->
  </ion-toolbar>
</ion-header>
<ion-content [scrollY]="false" class="ion-padding">
  <ion-grid>
    <ion-row>
      <ion-col>
        <swiper-container pager #slides autoplay-delay="7000" [pagination]="true" [navigation]="true">
          <swiper-slide class="ion-text-center">
            <ion-grid>
              <ion-row>
                <div class="image why_smartcr"></div>
              </ion-row>
              <ion-row>
                <h5 translate>We believe you should have access to the care you need in the comfort of your own home.</h5>
              </ion-row>
              <ion-row>
                <h6 class="swiper-text"></h6>
              </ion-row>
            </ion-grid>
          </swiper-slide>
          <swiper-slide class="ion-text-center">
            <ion-grid>
              <ion-row>
                <div class="image support_clinician"></div>
              </ion-row>
              <ion-row>
                <h5 translate>Support from your local Clinician</h5>
              </ion-row>
              <ion-row>
                <h6 class="swiper-text" translate>Good help is hard to find, which is why we connect you with your local clinician for the
                  support you need.</h6>
              </ion-row>
            </ion-grid>
          </swiper-slide>
          <swiper-slide class="ion-text-center">
            <ion-grid>
              <ion-row>
                <div class="image healthier_habits"></div>
              </ion-row>
              <ion-row>
                <h5 translate>Build healthier habits by completing tasks</h5>
              </ion-row>
              <ion-row>
                <h6 class="swiper-text" translate>After registering you will receive tasks from your clinician to help you build healthier
                  habits.</h6>
              </ion-row>
            </ion-grid>
          </swiper-slide>
          <swiper-slide class="ion-text-center">
            <ion-grid>
              <ion-row>
                <div class="image medicine_reminders"></div>
              </ion-row>
              <ion-row>
                <h5 translate>Set and (don’t) forget your medicines</h5>
              </ion-row>
              <ion-row>
                <h6 class="swiper-text" translate>Manage your medicines and get reminders so you don’t forget to take them.</h6>
              </ion-row>
            </ion-grid>
          </swiper-slide>
          <swiper-slide class="ion-text-center">
            <ion-grid>
              <ion-row>
                <div class="image track_progress"></div>
              </ion-row>
              <ion-row>
                <h5 translate>Track your progress in one place</h5>
              </ion-row>
              <ion-row>
                <h6 class="swiper-text" translate>Keep track of your health measures, activities, goals and symptoms with your diary.</h6>
              </ion-row>
            </ion-grid>
          </swiper-slide>
        </swiper-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="auth-footer">
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="6">
        <ion-button expand="block" (click)="goToRegister()" class="auth-button secondary">{{(viewModel$ | async)?.registerButtonText}}</ion-button>
      </ion-col>
      <ion-col size="12" size-md="6">
        <ion-button expand="block" (click)="goToLogin()" class="auth-button primary">{{(viewModel$ | async)?.loginButtonText}}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
